import React from "react";
import { Container } from "react-bootstrap";
import "../../scss/news-styling-component/news-pagination.style.scss";
import { useTranslation } from "react-i18next";
import { GreyRightArrow, LeftArrow } from "../images/svg/icons";

interface NewsPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  handlePages: (page: number) => void;
}

export const NewsPagination: React.FC<NewsPaginationProps> = ({ currentPage, totalPages, onPageChange, handlePages }) => {
  const { t } = useTranslation();


  return (
    <section className="news-pagination">
      <Container>
        <div className="news-pagination-container">
          <button className="news-pagination-button news-pagination-button--prev" disabled={currentPage === 1} onClick={() => handlePages(currentPage - 1)} >
            <img src={LeftArrow} alt={t("ALT_ARROW")} />
            <span>{t("PREVIOUS")}</span>
          </button>

          <div className="news-pagination-numbers">
            <button
              key={`page-${currentPage}`}
              className={`news-pagination-number ${currentPage === currentPage ? "news-pagination-number--active" : ""}`}
            >
              {currentPage}
            </button>
          </div>

          <button className="news-pagination-button news-pagination-button--next" disabled={currentPage === totalPages} onClick={() => handlePages(currentPage + 1)} >
            <span>{t("NEXT")}</span>
            <img src={GreyRightArrow} alt={t("ALT_ARROW")} />
          </button>
        </div>
      </Container>
    </section>
  );
};
